export default __webpack_public_path__ + "static/media/gamification-spin.74ebc6f0.png";